import { render, staticRenderFns } from "./EditOption.vue?vue&type=template&id=066133c8"
import script from "./EditOption.vue?vue&type=script&lang=ts"
export * from "./EditOption.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports